var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.loginVisible,
        "show-close": false,
        "close-on-click-modal": false,
        "close-on-press-escape": false
      },
      on: {
        "update:visible": function($event) {
          _vm.loginVisible = $event
        }
      }
    },
    [
      _c("div", { staticClass: "login_box" }, [
        _c(
          "div",
          { staticClass: "login_right" },
          [
            _c("div", { staticClass: "tag" }, [
              _c("i", { staticClass: "el-icon-close", on: { click: _vm.back } })
            ]),
            _vm._v(" "),
            _c("img", {
              staticClass: "shopvidi_logo",
              attrs: { src: require("@/assets/img/shopvidi_logo.png"), alt: "" }
            }),
            _vm._v(" "),
            _vm.type === "login"
              ? _c(
                  "el-form",
                  { ref: "loginForm", attrs: { model: _vm.loginForm } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "email",
                          rules: [
                            {
                              required: true,
                              message: "Please enter the email",
                              trigger: "blur"
                            },
                            {
                              type: "email",
                              message:
                                "Please enter the correct email address or password",
                              trigger: ["blur", "change"]
                            }
                          ]
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "Email" },
                          model: {
                            value: _vm.loginForm.email,
                            callback: function($$v) {
                              _vm.$set(_vm.loginForm, "email", $$v)
                            },
                            expression: "loginForm.email"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "password",
                          rules: {
                            required: true,
                            message:
                              "Please enter the correct email address or password",
                            trigger: "blur"
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: { type: "text", placeholder: "Password" },
                          on: { focus: _vm.changeType },
                          model: {
                            value: _vm.loginForm.password,
                            callback: function($$v) {
                              _vm.$set(_vm.loginForm, "password", $$v)
                            },
                            expression: "loginForm.password"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-checkbox",
                          {
                            model: {
                              value: _vm.loginForm.remember,
                              callback: function($$v) {
                                _vm.$set(_vm.loginForm, "remember", $$v)
                              },
                              expression: "loginForm.remember"
                            }
                          },
                          [_vm._v("Remember")]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item", [
                      _c("p", { staticClass: "text_agreen" }, [
                        _vm._v("By clicking Login, you agree to our "),
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "https://www.shopvidi.com/term-service"
                            }
                          },
                          [
                            _c("span", { staticClass: "organ_color" }, [
                              _vm._v("Terms of Service")
                            ])
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { loading: _vm.loading, type: "primary" },
                        on: {
                          click: function($event) {
                            return _vm.submitForm("loginForm")
                          }
                        }
                      },
                      [_vm._v("Login\n        ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "register",
                        on: {
                          click: function($event) {
                            return _vm.changeForm("register")
                          }
                        }
                      },
                      [_vm._v("Register")]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "register"
              ? _c(
                  "el-form",
                  {
                    ref: "registerForm",
                    staticStyle: { width: "90%" },
                    attrs: { model: _vm.registerForm }
                  },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "username",
                          rules: {
                            required: true,
                            validator: _vm.userNameCheck,
                            trigger: "blur"
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "First Name",
                            oninput: "if(value){value=value.toLowerCase()}",
                            onblur: "if(value){value=value.trim()}"
                          },
                          model: {
                            value: _vm.registerForm.firstName,
                            callback: function($$v) {
                              _vm.$set(_vm.registerForm, "firstName", $$v)
                            },
                            expression: "registerForm.firstName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "username",
                          rules: {
                            required: true,
                            validator: _vm.userNameCheck2,
                            trigger: "blur"
                          }
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "Last Name",
                            oninput: "if(value){value=value.toLowerCase()}",
                            onblur: "if(value){value=value.trim()}"
                          },
                          model: {
                            value: _vm.registerForm.lastName,
                            callback: function($$v) {
                              _vm.$set(_vm.registerForm, "lastName", $$v)
                            },
                            expression: "registerForm.lastName"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          prop: "email",
                          rules: [
                            {
                              required: true,
                              message: "Please enter the email",
                              trigger: "blur"
                            },
                            { validator: _vm.checkEmail, trigger: "blur" }
                          ]
                        }
                      },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "Business Email",
                            oninput: "if(value){value=value.toLowerCase()}",
                            onblur: "if(value){value=value.trim()}"
                          },
                          model: {
                            value: _vm.registerForm.email,
                            callback: function($$v) {
                              _vm.$set(_vm.registerForm, "email", $$v)
                            },
                            expression: "registerForm.email"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "flex cust-form-item cust-form-item2",
                        attrs: {
                          prop: "countryCode",
                          rules: {
                            validator: _vm.checkPhone,
                            trigger: "change"
                          }
                        }
                      },
                      [
                        _c(
                          "el-select",
                          {
                            attrs: {
                              filterable: "",
                              placeholder: "+ Country Code"
                            },
                            on: { change: _vm.codeChange },
                            model: {
                              value: _vm.codeObject,
                              callback: function($$v) {
                                _vm.codeObject = $$v
                              },
                              expression: "codeObject"
                            }
                          },
                          _vm._l(_vm.options, function(item, index) {
                            return _c(
                              "el-option",
                              {
                                key: index,
                                attrs: { label: item.text, value: item }
                              },
                              [
                                _c("span", { staticStyle: { float: "left" } }, [
                                  _vm._v(_vm._s(item.text))
                                ]),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      float: "right",
                                      color: "#8492a6",
                                      "font-size": "13px"
                                    }
                                  },
                                  [_vm._v(_vm._s(item.value))]
                                )
                              ]
                            )
                          }),
                          1
                        ),
                        _vm._v(" "),
                        _c("el-input", {
                          attrs: { placeholder: "Phone" },
                          on: { input: _vm.changePhone },
                          model: {
                            value: _vm.registerForm.phone,
                            callback: function($$v) {
                              _vm.$set(_vm.registerForm, "phone", $$v)
                            },
                            expression: "registerForm.phone"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      {
                        staticClass: "cust-form-item",
                        attrs: {
                          prop: "password",
                          rules: {
                            validator: _vm.handlePasswordLevel,
                            trigger: "change"
                          }
                        }
                      },
                      [
                        _c(
                          "el-input",
                          {
                            attrs: {
                              type: _vm.passw,
                              autocomplete: "new-password",
                              placeholder: "Password"
                            },
                            on: { focus: _vm.changeType },
                            model: {
                              value: _vm.registerForm.password,
                              callback: function($$v) {
                                _vm.$set(_vm.registerForm, "password", $$v)
                              },
                              expression: "registerForm.password"
                            }
                          },
                          [
                            _c(
                              "i",
                              {
                                attrs: { slot: "suffix" },
                                on: { click: _vm.showPass },
                                slot: "suffix"
                              },
                              [
                                _vm.passw == "password"
                                  ? _c("img", {
                                      staticClass: "reg-show-hide-icon",
                                      attrs: {
                                        src: require("@/assets/img/icon-hide.png"),
                                        alt: ""
                                      }
                                    })
                                  : _c("img", {
                                      staticClass: "reg-show-hide-icon",
                                      attrs: {
                                        src: require("@/assets/img/icon-show.png"),
                                        alt: ""
                                      }
                                    })
                              ]
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text_agreen_register" }, [
                      _vm._v("By clicking Login, you agree to our "),
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://www.shopvidi.com/term-service"
                          }
                        },
                        [
                          _c("span", { staticClass: "organ_color" }, [
                            _vm._v("Terms of Service")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "primary", loading: _vm.loading },
                        on: {
                          click: function($event) {
                            return _vm.submitForm("registerForm")
                          }
                        }
                      },
                      [_vm._v("Next\n        ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "text_agreen_register" }, [
                      _vm._v("Already have ShopVidi account?"),
                      _c(
                        "span",
                        {
                          staticClass: "login-now",
                          on: {
                            click: function($event) {
                              return _vm.changeForm("login")
                            }
                          }
                        },
                        [_vm._v("Log in now")]
                      )
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08df88a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08df88a2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/home/register/register-dialog.vue
// module id = /4hA
// module chunks = 2